export default {
  state: {
    title: 'Status',
    visible: 'Tischbestellung sichtbar',
    on: 'Tischbestellung',
  },
  notes: {
    hidden: {
      title: 'Tischbestellung ist ausgeblendet',
      description:
        'Sie ist eingeschaltet, aber Ihr Shop zeigt sie nicht an, daher wird jede Tischbestellung abgelehnt. Schalten Sie „Tischbestellung sichtbar“ ein, um sie anzuzeigen.',
      link: 'Zum Schalter',
    },
    off: {
      title: 'Gäste können gerade nicht am Tisch bestellen',
      description:
        'Schalten Sie beide Schalter ein, um zu starten. Bis dahin öffnet der QR-Code eines Tisches Ihren Shop mit Abholung und Lieferung.',
    },
    no_active_table: {
      title: 'Gäste können noch nicht am Tisch bestellen',
      description: 'Fügen Sie unten einen Tisch hinzu und schalten Sie ihn ein.',
    },
  },
  buttons: {
    save: 'Speichern',
  },
};
